export const handleEmailSubmit = ({ launchModal, ...requestBody }) => {
  fetch(
    `https://europe-west3-biwebsite.cloudfunctions.net/newsletter_signup_mailchimp`,
    {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => {
      if (response.ok) {
        document.cookie = "exit_intent_cookie=pause;max-age=31556926;path=/"
        launchModal(true)
      } else {
        launchModal(false)
      }
    })
    .catch(() => {
      launchModal(false)
    })
}
